<template>
    <div id="historical-prices">
        <div class="prices-tab-nav">
            <div class="tab" :class="{ active: activePeriod === 'month' }" @click="updateActive('month')">
                <h3 class="header">
                    <i class="icon"
                        :class="{ 'icon-right-carrot': activePeriod === 'year', 'icon-down-carrot': activePeriod === 'month' }" />
                    Historical Prices Month-End
                </h3>
            </div>
            <div class="tab" :class="{ active: activePeriod === 'year' }" @click="updateActive('year')">
                <h3 class="header">
                    <i class="icon icon-down-carrot" />
                    Historical Prices Year-End
                </h3>
            </div>
            <!--Historical prices links, hiding for now (CG-17099)-->
            <!-- <a class="historical-prices-link large" :href="historicalPricesLink" v-if="isTargetDate">
				<div class="arrow-wrapper">
					<i class="icon icon-arrow-right" />
				</div>
				FIND HISTORICAL PRICES
			</a>-->
        </div>
        <div class="prices-nav">
            <button @click="updateDateRange('previous')">
                <i class="icon icon-left-carrot" />
            </button>
            <div class="date-range">{{ dateRangeText }}</div>
            <button @click="updateDateRange('next')">
                <i class="icon icon-right-carrot" />
            </button>
        </div>
        <div class="img-container">
            <img :src="chart" :class="{ 'hidden-img': isLoading }" alt="historical-prices" />
            <div v-if="isLoading" id="historical-loading-gif" />
        </div>
        <div class="prices-tab-nav-bottom">
            <div class="tab" :class="{ active: activePeriod === 'year' }" @click="updateActive('year')">
                <h3 class="header">
                    <i class="icon icon-right-carrot" />
                    Historical Prices Year-End
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'HistoricalPrices',
    data() {
        return {
            endYear: new Date().getFullYear(),
            year: new Date().getFullYear(),
            activePeriod: 'month',
            isLoading: true
        };
    },
    computed: {
        ...mapGetters([
            'historicalPrices',
            'getFundAttributes'
        ]),
        chart() {
            return this.activePeriod === 'month'
                ? this.widgetData.monthChart
                : this.widgetData.yearChart;
        },
        objective() {
            return this.getFundAttributes && this.getFundAttributes.Objective;
        },
        dateRangeText() {
            let text = '';
            if (this.activePeriod === 'month') {
                text = this.year;
            } else if (this.activePeriod === 'year') {
                text = `${this.endYear - 9} - ${this.endYear}`;
            }
            return text;
        },
        widgetData() {
            return {
                ...this.historicalPrices,
                objective: this.objective
            };
        },
        isTargetDate() {
            return this.objective === 'RetirementTargetDate';
        }
    },
    methods: {
        updateChart() {
            this.$store.dispatch('getAndCommit', {
                endpoint: 'historicalprices',
                commitId: this.activePeriod === 'month' ? 'SET_HISTORICAL_PRICES_MONTH' : 'SET_HISTORICAL_PRICES_YEAR',
                fundNumber: this.getFundAttributes.FundNumber,
                shareClass: this.getFundAttributes.ShareClass,
                stagingFlag: this.$store.state.stagingFlag,
                startDate: this.activePeriod === 'year' ? this.endYear - 10 : this.year - 1,
                endDate: this.activePeriod === 'year' ? this.endYear : this.year
            });
        },
        updateDateRange(yearRange) {
            //saving a unique date variable for the month end and year end chart. so that traversing the timeline of one will not change the other/ reduce calls for the chart
            //in image foundry (used in the api call to get the chart), the difference  of startYear and EndYear determin if it returns the month or year chart.
            if (this.activePeriod === 'year') {
                if (yearRange === 'previous') this.endYear -= 9;
                if (yearRange === 'next') this.endYear += 9;
            } else if (this.activePeriod === 'month') {
                if (yearRange === 'previous') this.year -= 1;
                if (yearRange === 'next') this.year += 1;
            }
            this.isLoading = true;
            this.updateChart();
        },
        updateActive(period) {
            if (
                (period === 'month' && !this.widgetData.monthChart) ||
                (period === 'year' && !this.widgetData.yearChart)
            ) {
                this.isLoading = true;
            }
            this.activePeriod = period;
            this.updateChart();
        }
    },
    watch: {
        widgetData(newVal) {
            if (this.activePeriod === 'month' && newVal.monthChart) {
                this.isLoading = false;
            }
            if (this.activePeriod === 'year' && newVal.yearChart) {
                this.isLoading = false;
            }
            this.isLoading = false;
        }
    }
};
</script>

<style lang="less">
@import '~_css_/tabs.less';

#historical-prices {
    .module-border-top();
    margin-bottom: 35px;

    .prices-nav {
        height: 38px;
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        border-top: 1px solid rgb(212, 212, 212);
        border-bottom: 1px solid rgb(212, 212, 212);
        background-color: #f5f5f5;

        button {
            width: 26px;
            height: 26px;
            background-color: white;
            color: #52bdec;
            cursor: pointer;
            margin: 0px 30px;
            border-radius: 3px;
            border-width: 1px;
            border-style: solid;
            border-color: #d4d4d4;
            border-image: initial;
            font-weight: 100;
            font-size: 30px;
            line-height: 0;

            .icon {
                font-size: 12px;
                line-height: 12px;
            }

            &:focus {
                outline: none;
            }
        }

        .date-range {
            display: inline-block;
            text-align: center;
            line-height: 26px;
            flex: 1;
        }
    }

    .img-container {
        height: auto;
        position: relative;
        width: 100%;
        padding-top: 25%;

        img {
            width: 100%;
            position: absolute;
            top: 0px;

            &.hidden-img {
                opacity: 0.4;
            }
        }

        #historical-loading-gif {
            background: url('../../assets/img/loading.gif') no-repeat center center;
            background-size: auto;
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0px;
        }
    }

    .prices-tab-nav-bottom .tab {
        display: none;
    }

    .tab .icon {
        display: none;
    }

    .historical-prices-link {
        color: #1d5799;
        display: block;
        font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
        font-size: 14px;
        margin-top: 10px;
        margin-left: auto;
        margin-bottom: 30px;
        text-transform: uppercase;

        .arrow-wrapper {
            display: inline-block;
            color: #878a96;

            .icon {
                line-height: 15px;
            }
        }

        &.large {
            float: right;
        }
    }

    @media (max-width: 768px) {
        .tab .icon {
            display: initial;
        }

        .prices-tab-nav-bottom {
            .tab {
                display: block;
                margin-top: 20px;

                &.active {
                    background-color: #999;
                    background-image: linear-gradient(to bottom, #999, #999);
                    color: #fff;
                    cursor: pointer;
                    display: none;
                    margin-bottom: 20px;
                }
            }
        }

        .prices-tab-nav {
            div {
                margin: 0;
                margin-bottom: 2px;
                display: block;

                &:last-child {
                    display: none;
                }

                &.active {
                    background-color: #999;
                    background-image: linear-gradient(to bottom, #999, #999);
                    color: #fff;
                    cursor: pointer;
                    margin-bottom: 20px;
                    display: block;
                }
            }
        }
    }
}
</style>
